import * as React from "react";
import { IFlexibleSetPriceProps } from "../../../../types/article-price";
import { formatPrice } from "../../../../util/priceFormatter";
import { useL10nContext } from "../../../common/contexts";
import "./article-price.scss";

const FlexibleSetPrice = (props: IFlexibleSetPriceProps) => {
    const { decodePriceL10n } = useL10nContext();
    const priceL10n = decodePriceL10n();

    const showAsDiscounted = props.prices.discountType !== "FreeItem";

    const priceString = (priceValue: number) => {
        return formatPrice(priceValue, props.priceSettingsV2);
    };

    return (
        <div className={"article-price"}>
            <div className={"price-info"}>
                <div>
                    {showAsDiscounted && (
                        <>
                            <div className="strike-price net">
                                <span className="value">
                                    {priceString(props.prices.originalPrice.netValue)}
                                </span>
                            </div>
                            <div className="strike-price gross">
                                <span className="value">
                                    {priceString(props.prices.originalPrice.grossValue)}
                                </span>
                            </div>
                            &nbsp;
                        </>
                    )}
                    <div className={"price" + `${showAsDiscounted ? " discounted" : ""}` + " net"}>
                        <span className="value">{priceString(props.prices.price.netValue)}</span>
                    </div>
                    <div
                        className={"price" + `${showAsDiscounted ? " discounted" : ""}` + " gross"}
                    >
                        <span className="value">{priceString(props.prices.price.grossValue)}</span>
                    </div>
                </div>
            </div>

            <div className={"vat-info"}>
                <span className="price-mode net">({priceL10n.exVATAcronym})</span>
                <span className="price-mode gross">({priceL10n.incVATAcronym})</span>
            </div>
        </div>
    );
};

export default FlexibleSetPrice;
